import {IValidationError} from "./IValidationError";
import {IValidationResultOptions} from "./IValidationResultOptions";

export class ValidationResult {
    public isValid: boolean = true;
    public errors: IValidationError[] = [];

    private options: IValidationResultOptions;

    constructor(options: Partial<IValidationResultOptions> = {}) {
        this.options = $.extend(this.getDefaultOptions(), options);
    }

    push(validationError: IValidationError) {
        this.isValid = false;
        this.errors.push(validationError);
    }

    mark(form: JQuery) {
        form.data('validationResult', this);

        for (let error of this.errors) {
            error.formField
                .on('change.validator', () => this.revalidate(error))
                .closest(this.options.fieldContainerSelector)
                .addClass(this.options.errorClassName);

            $('<label>', {
                "class": this.options.errorMessageClassName,
                text: error.message
            }).insertAfter(error.formField);
        }
    }

    clear(form: JQuery) {
        form.removeData('validationResult');

        for (let error of this.errors) {
            this.clearField(error.formField);
        }
    }

    clearField(formField: JQuery) {
        formField
            .off('change.validator')
            .closest(this.options.fieldContainerSelector).removeClass(this.options.errorClassName)
            .find(`.${this.options.errorMessageClassName}`).remove();
    }

    private revalidate(validationError: IValidationError) {
        if (!validationError.validator.isValid(validationError.formField))
            return;

        this.clearField(validationError.formField);
    }

    private getDefaultOptions() {
        return {
            fieldContainerSelector: '.field-group',
            errorClassName: 'error',
            errorMessageClassName: 'field-message'
        }
    }
}



// WEBPACK FOOTER //
// ./validation/ValidationResult.ts